let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9AHCA")).then(() => parcelRequire('9EIlP'));